import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiPopper: Components<Theme>['MuiPopper'] = {
  styleOverrides: {
    root: () => ({
      marginTop: '4px !important',
      '& .MuiPaper-root': {
        borderRadius: '10px',
        border: '1px solid #D4D8E3',
      },
    }),
  },
};
